<template>
  <div class="layout">
    <el-container>
      <el-header>
        <lay-header />
      </el-header>
      <el-container>
        <el-aside>
          <lay-nav />
        </el-aside>
        <el-main>
          <lay-main />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import LayHeader from "./AppHeader.vue";
import LayNav from "./Sidebar";
import LayMain from "./AppMain.vue";
export default {
  components: { LayHeader, LayNav, LayMain },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.layout {
  .el-header {
    background: #ffffff;
    height: 56px !important;
    padding: 0;
  }
  ::v-deep .el-aside {
    height: calc(100vh - 56px);
    width: 216px !important;
    padding: 8px;
    box-sizing: border-box;
    background: #fff;
    > div {
      height: 100%;
    }
    .el-menu {
      border: none !important;
      > div {
        margin-bottom: 4px;
        > .is-active {
          background: none;
        }
      }
      .el-menu-item {
        padding: 9px 16px !important;
        display: flex;
        align-items: center;
        line-height: 40px;
        height: 40px;
        > span {
          line-height: 40px;
          margin-left: 8px;
          color: #262626;
        }
        .iconfont {
          margin: 0;
          display: block;
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .is-active {
        background: #ffede8;
        border-radius: 4px;
        > span {
          color: #ff5d2f;
          line-height: 40px;
          font-weight: 500;
        }
      }
      .is-active {
        .el-menu-item:hover {
          background: #ffede8;
        }
      }
      .el-menu-item:hover {
        background: none;
        color: #ff5d2f;
        > span {
          color: #ff5d2f;
        }
      }
      .el-submenu {
        .el-submenu__title {
          padding: 9px 16px !important;
          display: flex;
          align-items: center;
          > span {
            line-height: 40px;
            margin-left: 8px;
            color: #262626;
            font-weight: 500;
          }
          .iconfont {
            margin: 0;
            display: block;
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .el-submenu__icon-arrow::before {
            font-size: 14px;
            font-weight: 800;
          }
        }
        .el-submenu__title:hover {
          background: none;
          > span {
            color: #474646;
          }
          .el-submenu__icon-arrow::before {
            color: #474646;
          }
        }
        .el-menu-item {
          padding-left: 40px !important;
          span {
            margin: 0;
          }
        }
      }
      .is-opened {
        .el-submenu__title {
          background: none;
          > span {
            color: #ff5d2f;
          }
          .el-submenu__icon-arrow::before {
            color: #ff5d2f;
            font-size: 14px;
            font-weight: 800;
          }
        }
      }
    }
    // background: #001529;
  }
  .el-main {
    padding: 17px 20px 2px;
    background: #f7f8fa;
    height: calc(100vh - 80px);
  }
  .el-main::-webkit-scrollbar {
    overflow: hidden;
  }
  ::v-deep .el-aside::-webkit-scrollbar {
    overflow: hidden;
  }
}
</style>
